import React from 'react';
import { connect } from "react-redux";
import FooterComponent from '../components/footer/FooterComponent';
import { getFooterMenus } from "../store/footer/action";
import ReactGA from 'react-ga4';

class FooterContainer extends React.Component {

   constructor(props) {
     super(props);
 
     this.menuClicked = this.menuClicked.bind(this);
   }
  /**
   * @method componentDidMount
   * to load the data after state changed
   */
  componentDidMount() {
    this.props.getFooterMenus();
  }

  menuClicked(eventLabel) {
    ReactGA.event('Click',{
      category: 'Navigate',
      action: 'Click',
      event_category: 'Navigate',
      event_action: 'Click',
      event_label: eventLabel,
      UserID: (this.props.auth.auth.userId) ?  this.props.auth.auth.userId : 'noAuth'
    });
  }

  /**
   * @render to load the view file
   */
  render() {
    if (this.props.auth && this.props.auth.auth && this.props.auth.auth.isAppHeader) {
      return (
        <div></div>
      );
    }
    else {
      return (
        <div>
          <FooterComponent menus={this.props.footer} menuClicked={this.menuClicked} />
        </div>
      );
    }
  }

}

/** @mapDispatchToProps
 *  dispatch method to props  
 */

const mapDispatchToProps = {
  getFooterMenus: getFooterMenus
};

/** @mapStateToProps
 *  map state to props  
 */

const mapStateToProps = (state) => ({
  footer: state.footerReducer,
  auth: state.auth
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FooterContainer);
